module.exports = __webpack_public_path__ + "img/default-question-continuously-insured.8aa20ab3.svg";